import {
  NEWS_REQUESTED,
  GET_NEWS_SUCCESS,
  SET_FILTERED_DATA,
  GET_NEWS_FAILURE,
  SET_ERROR,
  SET_LOADING,
  SET_NEWS_MODAL_STATE,
  REMOVE_NEWS_MODAL_STATE,
  GET_PAGE_DATA_SUCCESS,
  GET_PAGE_DATA_INITIAL,
  GET_PAGE_DATA_FAILURE,
} from '../types/news.type'

const intialState = {
  originalNewsData: null,
  filteredNewsData: null,
  page: 0,
  hasMorePages: true,
  length: null,
  paginationLoading: false,
  loading: false,
  error: null,
  newsModalState: null,
}

const newsReducer = (state = intialState, action) => {
  switch (action.type) {
    case NEWS_REQUESTED:
      return { ...state, loading: true, error: null }

    case GET_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        page: 1,
        hasMorePages: true,
        originalNewsData: action.payload.data,
        filteredNewsData: action.payload.data,
      }

    case GET_NEWS_FAILURE: {
      return { ...state, loading: false, error: action.payload }
    }

    case SET_FILTERED_DATA:
      return {
        ...state,
        filteredNewsData: action.payload,
        loading: false,
        error: null,
      }

    case GET_PAGE_DATA_INITIAL:
      return { ...state, paginationLoading: true, paginationError: null }

    case GET_PAGE_DATA_SUCCESS:
      return {
        ...state,
        page: action.payload.count != 0 ? state.page + 1 : state.page,
        paginationLoading: false,
        hasMorePages: action.payload.count == 30,
        filteredNewsData: [...state.filteredNewsData, ...action.payload.data],
        originalNewsData: [...state.originalNewsData, ...action.payload.data],
      }

    case GET_PAGE_DATA_FAILURE:
      return {
        ...state,
        paginationError: action.payload,
        paginationLoading: false,
      }

    case SET_LOADING:
      return { ...state, loading: action.payload }

    case SET_ERROR:
      return { ...state, error: action.payload }

    case SET_NEWS_MODAL_STATE: {
      localStorage.setItem('newsId', action.payload.news_id)
      return {
        ...state,
        newsModalState: action.payload,
      }
    }
    case REMOVE_NEWS_MODAL_STATE: {
      localStorage.removeItem('newsId')
      return { ...state, newsModalState: null }
    }
    default:
      return state
  }
}

export default newsReducer
